import React from "react";
import "./ContactUsContent.css";

function ContactUsContent() {
  return (
    <>
      {/* Float Icon Start */}
      <div className="floatIconsContainer">
        <img
          src="/images/homePage/Icon ionic-md-mail.png"
          alt="Mail-Icon"
          className="FloatIconMailIcon"
        />
        <p className="FloatIconName">Contact Us</p>
      </div>
      {/* Float Icon End */}
      {/* Banner Start */}
      <div className="main-banner">
        <img
          src="/images/ContactUs/Contact.png"
          alt="Banner"
          className="LearningBanner"
        />
        <h2 id="ourLeadBannerText">Lorem ipsum dolor sit amet</h2>
        {/* Banner End */}
        {/* <Floaticons /> */}
      </div>
      <div className="contactUsSection">
        <h2 className="ContactUsHeading">Contact Us</h2>
        <p className="contactUsSubheading">
          Get in touch and let us know how we can help.
        </p>
        <div className="contactUsCardContainer">
          <div className="contactUsCards">
            <img
              src="/images/ContactUs/Language Support.png"
              alt=""
              className="contactUsCardIcon"
            />
            <div className="contactUsCardsTextContainer">
              <a href="">
                <h6 className="contactUsCardsTextHeadiing">Language Support</h6>
              </a>
              <p className="contactUsCardsTextDetails">
                lorem ipsum dolor sit amet, consectetur adipiscing, lorem ipsum
                dolor sit amet
              </p>
            </div>
          </div>
          <div className="contactUsCards">
            <img
              src="/images/ContactUs/Certification Suppor.png"
              alt=""
              className="contactUsCardIcon"
            />
            <div className="contactUsCardsTextContainer">
              <a href="">
                <h6 className="contactUsCardsTextHeadiing">
                  Certification Support
                </h6>
              </a>
              <p className="contactUsCardsTextDetails">
                lorem ipsum dolor sit amet, consectetur adipiscing, lorem ipsum
                dolor sit amet
              </p>
            </div>
          </div>
          <div className="contactUsCards">
            <img
              src="/images/ContactUs/Mentor Support.png"
              alt=""
              className="contactUsCardIcon"
            />
            <div className="contactUsCardsTextContainer">
              <a href="">
                <h6 className="contactUsCardsTextHeadiing">Mentor Support</h6>
              </a>
              <p className="contactUsCardsTextDetails">
                lorem ipsum dolor sit amet, consectetur adipiscing, lorem ipsum
                dolor sit amet
              </p>
            </div>
          </div>
        </div>
        {/* Yammer Button */}
        <div className="yammerButtonContainer">
          <a href="" className="yammerLink">
            Join us on Yammer
          </a>
        </div>
      </div>
      {/* Write On Us Start */}
      <div className="writeOnUsContainer">
        <img
          src="/images/ContactUs/Write to us BG.png"
          alt="Background"
          className="writeOnUsBg"
        />
        <div className="writeOnUsTextContainer">
          <h2 className="writeOnUsTextHeading">Write to Us</h2>
          <form action="#" method="post" className="writeToUsForm">
            <p>
              <label for="writeToUS" className="writeToUsFormHeading">
                {" "}
                How are you feeling, share your thoughts with us...
              </label>
            </p>
            <textarea
              id="writeToUS"
              name="writeToUS"
              type="textarea"
              className="textareaInput"
            />
            <button
              type="submit"
              value="Submit"
              className="writeOnUsSendButton"
            >
              <img
                src="/images/ContactUs/Send hover.png"
                alt="Background"
                width="100%"
              />
            </button>
          </form>
        </div>
      </div>
      {/* Write On Us End */}
    </>
  );
}

export default ContactUsContent;
